import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { CardPageRoutingModule } from './card-routing.module';

import { CardPage } from './card.page';
import { MpImageViewerModule } from 'src/app/shared/components/image-viewer/image-viewer.module';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from 'src/app/shared/pipe/pipe.module';
import { MpImgPageModule } from '../image-tag/image-tag.module';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    CardPageRoutingModule,
    MpImageViewerModule,
    TranslateModule,
    PipesModule,
    MpImgPageModule
  ],
  declarations: [CardPage],
  exports: [
    CardPage
  ]
})
export class CardPageModule {}
